<template>
  <div class="setting_modal">
    <div class="setting_customize">
      <div class="setting_customize_header">
        <p class="setting_customize_header_title">
          {{ labelProperties.PREVIEW_TITLE }}
        </p>
        <div class="setting_customize_header_close" @click="$emit('close'); step = 1">
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#AAA" fill-rule="evenodd">
              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
            </g>
          </svg>
        </div>
      </div>
      <div class="setting_customize_body">
        <div
          class="setting_customize_preview"
          v-bind:style="{ backgroundColor: colors.pageBackground }"
        >
          <div class="jobs_wrapper" id="top_modal_preview">
            <template v-if="step === 1">
              <h1
                class="jobs_page_title_preview setting_word_break"
                v-bind:style="{ color: colors.pageText }"
                v-if="jobPageName"
              >
                {{ jobPageName }}
              </h1>
              <h1
                class="jobs_page_title"
                v-bind:style="{ color: colors.pageText }"
                v-else
              >
                {{ labelProperties.JOB_PAGE_TITLE }}
              </h1>
            <p class="jobs_table_annotation_preview setting_word_break" v-if="jobOverview">{{ jobOverview }}</p>
              <div class="jobs_table_wrapper">
                <template v-for="(category, indexOfCategory) in categoriesSearchJob">
                  <template v-if="category && !category.categoryDeleted && !isEmptyCategoryInJobSearch(indexOfCategory)">
                    <h2 class="jobs_category_title mt-3" v-bind:key="indexOfCategory"
                    v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                      {{ category.categoryName }}
                    </h2>
                    <table
                      v-for="(item, index) in category.item"
                      class="jobs_table"
                      v-bind:style="{ backgroundColor: colors.pageBackground }"
                      :key="'c_' + indexOfCategory + 'i_' + index"
                    >
                      <tbody class="jobs_table_body" v-if="!item.itemDeleted && !item.resourceField[0].isItemDeletedByMainSystem">
                        <tr class="jobs_table_rows">
                          <th
                            class="jobs_table_head"
                            v-bind:style="[
                              { backgroundColor: colors.subColor },
                              index === 0
                                ? { border: '1px solid' + colors.borderColor }
                                : {
                                    borderLeft: '1px solid' + colors.borderColor,
                                    borderRight: '1px solid' + colors.borderColor,
                                    borderBottom: '1px solid' + colors.borderColor,
                                  },
                            ]"
                          >
                            <div class="jobs_table_head_holder">
                              <span
                                class="jobs_table_label"
                                v-bind:style="{ color: colors.pageText }"
                              >
                                {{ item.itemName }}
                              </span>
                            </div>
                          </th>
                          <td
                            class="jobs_table_cell"
                            v-bind:style="[
                              index === 0
                                ? { border: '1px solid' + colors.borderColor }
                                : {
                                    borderLeft: '1px solid' + colors.borderColor,
                                    borderRight: '1px solid' + colors.borderColor,
                                    borderBottom: '1px solid' + colors.borderColor,
                                  },
                            ]"
                          >
                            <div class="jobs_table_form_rows">
                              <div class="jobs_table_form_item">
                                <InputComponent
                                  class="mt-3"
                                  :resource="item.resourceField[0]"
                                  :master="getMasterData(item.resourceField[0].master_name)"
                                  :itemJob="true"
                                  :itemName="item.itemName"
                                  :draftColors="colors"
                                />
                                <div
                                  v-if="item.viewAnnotation && item.annotationText"
                                >
                                  <span class="jobs_table_annotation setting_word_break" v-bind:style="{ color: colors.pageText }">
                                    ※{{ item.annotationText }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </template>
                <h2 class="jobs_category_title mt-3"
                    v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                  {{ labelProperties.CATEGORY_FREE_WORD }}
                </h2>
                <table class="jobs_table">
                  <tbody class="jobs_table_body">
                    <tr class="jobs_table_rows">
                      <th
                        class="jobs_table_head"
                        v-bind:style="{
                          backgroundColor: colors.subColor,
                          borderLeft: '1px solid' + colors.borderColor,
                          borderBottom: '1px solid' + colors.borderColor,
                        }"
                      >
                        <div class="jobs_table_head_holder">
                          <span
                            class="jobs_table_label"
                            v-bind:style="{ color: colors.pageText }"
                            >{{ labelProperties.FREE_WORD_SEARCH }}</span
                          >
                        </div>
                      </th>
                      <td
                        class="jobs_table_cell"
                        v-bind:style="{
                          borderLeft: '1px solid' + colors.borderColor,
                          borderRight: '1px solid' + colors.borderColor,
                          borderBottom: '1px solid' + colors.borderColor,
                        }"
                      >
                        <div class="jobs_table_form_rows">
                          <div class="jobs_table_form_item mt-3">
                            <input
                              class="jobs_form_text"
                              type="text"
                              :placeholder="
                                labelProperties.PLACE_HOLDER_WORD_SEARCH
                              "
                              v-model="freeWord"
                            />
                          </div>
                        </div>
                        <div class="jobs_table_form_rows">
                          <div class="jobs_table_form_item">
                            <div class="jobs_table_form_label_box">
                              <label class="setting_form_radio_label">
                                <input
                                  type="radio"
                                  v-model="condition"
                                  id="and"
                                  value="and"
                                />
                                <span
                                  v-bind:style="{ color: colors.pageText }"
                                  for="and"
                                  class="setting_form_radio_text"
                                  >{{ labelProperties.AND }}
                                </span>
                              </label>
                              <label class="setting_form_radio_label">
                                <input
                                  type="radio"
                                  v-model="condition"
                                  id="or"
                                  value="or"
                                />
                                <span
                                  v-bind:style="{ color: colors.pageText }"
                                  for="or"
                                  class="setting_form_radio_text">{{ labelProperties.OR }}
                                </span>
                              </label>
                              <span
                                class="ml-3 jobs_table_annotation"
                                v-bind:style="{ color: colors.pageText }"
                                >{{ labelProperties.NOTICE_FREE_WORD }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="jobs_annotation_box">
                  <p class="jobs_annotation_text">
                    {{ labelProperties.NOTICE_CANT_SEARCH_COMBINATION }}
                  </p>
                </div>
                <div class="jobs_btn_box">
                  <button
                    class="jobs_btn_primary mt-5"
                    v-bind:style="{
                      color: colors.mainButtonText,
                      backgroundColor: colors.mainButton,
                      border: '1px solid' + colors.borderColor,
                    }"
                    @click="searchJob()"
                  >
                    <span v-if="!button.searchBtn">
                      {{ labelProperties.CONFIRM_BUTTON }}
                    </span>
                    <span v-else>
                      {{ button.searchBtn }}
                    </span>
                  </button>
                </div>
              </div>
            </template>
            <template v-if="step === 2">
              <h1 class="jobs_page_title">
                {{ searchJobLabelsProperty.SEARCH_RESULT_LIST }}
              </h1>
              <h2 class="jobs_category_title">
                {{ searchJobLabelsProperty.CURRENT_SEARCH_CRITERIA }}
              </h2>
              <div class="jobs_search_condition">
                <div class="jobs_search_condition_inner">
                  <template v-if="!freeWord">
                    <template v-for="(category, indexOfCategory) in categoriesSearchJob">
                      <dl class="jobs_search_condition_list" :key="'c' + indexOfCategory">
                        <template v-for="(item, indexOfItem) in category.item">
                          <template v-if="!item.resourceField[0].isDeletedByMainSystem && item.resourceField[0].isHasValue">
                            <dt class="jobs_search_condition_label setting_word_break" :key="'c' + indexOfCategory + 'i' + indexOfItem">
                              {{ item.itemName }}
                            </dt>
                            <dd class="jobs_search_condition_desc setting_word_break" :key="'ci' + indexOfCategory + indexOfItem">
                              <span v-if="item.resourceField[0].default_value && (item.resourceField[0].type === 'text' || item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'url' || item.resourceField[0].type.includes('email')) || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'sequence'">
                                {{ item.resourceField[0].default_value }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value && (item.resourceField[0].type === 'multi_select' || item.resourceField[0].type === 'checkbox') && item.resourceField[0].default_value.length > 0">
                                {{ getValueCheckBox(item.resourceField[0].default_value) }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value !== null && (item.resourceField[0].type === 'single_select' || item.resourceField[0].type === 'select' || item.resourceField[0].type === 'boolean' || item.resourceField[0].type === 'radio')">
                                {{ getSingleSelect(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'datetime'">
                                {{ getValueDateTime(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'date'">
                                {{ getValueDate(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'ym'">
                                {{ getValueYearMonth(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].type === 'time'">
                                {{ getValueTime(item.resourceField[0]) }}
                              </span>
                              <span v-else-if="item.resourceField[0].default_value_from || item.resourceField[0].default_value_to">
                                {{ item.resourceField[0].default_value_from }} ~
                                {{ item.resourceField[0].default_value_to }}
                              </span>
                              <span v-else> -- </span>
                            </dd>
                          </template>
                        </template>
                      </dl>
                    </template>
                  </template>
                  <div class="jobs_search_setting" v-if="freeWord">
                    <div class="jobs_search_condition_label setting_word_break">
                      {{ searchJobLabelsProperty.FREE_WORD }}（
                      <span style="text-transform: uppercase"> {{ condition }} </span>)
                    </div>
                    <div class="jobs_search_condition_desc setting_word_break">
                      <span>
                        {{ freeWord }}
                      </span>
                    </div>
                  </div>
                  <template v-if="!numberOfSearchByItem && !freeWord">
                    <label>
                      {{searchJobLabelsProperty.NONE}}
                    </label>
                  </template>
                </div>
                <div class="jobs_search_condition_btn">
                  <button class="jobs_btn_secondary jobs_btn_medium"
                    v-bind:style="{
                      color: colors.subButtonText,
                      backgroundColor: colors.subButton
                    }"
                    @click="step = 1; scrollToTopOfModal()">
                    {{ searchJobLabelsProperty.BUTTON_CHANGE_CONDITON_SEARCH }}
                  </button>
                </div>
              </div>
              <div class="jobs_search_result" v-if="numberOfJobDisplay > 0">
                <span class="jobs_search_result_number">
                  {{ numberOfJobDisplay }}
                </span>
                <span class="jobs_search_result_unit">
                  {{ searchJobLabelsProperty.IN_PIECE }}
                </span>
                <span class="jobs_search_result_range">
                  1 ～ {{ numberOfJobDisplay }} {{ searchJobLabelsProperty.SHOW_MATTER }}
                </span>
              </div>

              <div class="jobs_result">
                <ul class="jobs_result_list" v-for="(job, indexJobDetail) in jobDetails" :key="indexJobDetail">
                  <li class="jobs_result_item">
                    <div class="jobs_result_inner">
                      <h2 class="jobs_result_heading" @click="step = 3">
                        <router-link to="" @click.native="scrollToTopOfModal()">
                          <a class="jobs_result_title" v-bind:style="{ color: colors.linkText }" style="text-decoration: none">
                            <template v-for="(headingSetting, index) in headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted)">
                                <span :key="'h' + index">
                                  {{headingSetting.display_name}} <span v-if="index < headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted).length - 1">/</span>
                                </span>
                            </template>
                          </a>
                        </router-link>
                      </h2>
                      <div class="jobs_result_text" v-for="(bodySetting, index) in bodySettings.filter(bodySetting => !bodySetting.itemResourceDeleted)" :key="index">
                        <span :key="'b' + index">
                          {{bodySetting.display_name}}
                        </span>
                      </div>
                      <template v-for="(category, cIndex) in categoriesJobList">
                        <template v-if="category && !category.categoryDeleted && !isEmptyCategory(categoriesJobList, cIndex)">
                          <h2 class="jobs_category_title mt-3" :key="'cl' + cIndex"
                              v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                            {{ category.categoryName }}
                          </h2>
                          <table class="jobs_detail_table" :key="'cls' + cIndex + indexJobDetail">
                            <tbody class="jobs_detail_table_body">
                              <template v-for="(item, index) in category.item">
                                <tr class="jobs_detail_table_rows"
                                    v-bind:key="item.resourceField[0].name">
                                  <th class="jobs_detail_table_head"
                                      v-bind:style="[{ backgroundColor: colors.subColor }, index === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                                    <span v-bind:style="{ color: colors.pageText }" class="setting_word_break">
                                      {{ item.itemName }}
                                    </span>
                                  </th>
                                  <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}">
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </template>
                      </template>
                    </div>
                    <div class="jobs_result_btn">
                      <button class="jobs_btn_primary"
                        v-bind:style="{
                          color: colors.mainButtonText,
                          backgroundColor: colors.mainButton
                        }"
                      @click="step = 3; scrollToTopOfModal()">
                        <span v-if="button.listBtn === ''">
                          {{ searchJobLabelsProperty.VIEW_DETAIL_JOB }}
                        </span>
                        <span v-else>
                          {{ button.listBtn }}
                        </span>
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="jobs_btn_box">
                <button class="jobs_btn_secondary jobs_btn_medium jobs_btn_disabled">
                  {{ searchJobLabelsProperty.BUTTON_BACK_PAGE }}
                </button>
                <button class="jobs_btn_secondary jobs_btn_medium"
                  v-bind:style="{
                    color: colors.subButtonText,
                    backgroundColor: colors.subButton
                  }"
                >
                  {{ searchJobLabelsProperty.BUTTON_NEXT_PAGE }}
                </button>
              </div>
            </template>

            <template v-if="step === 3">
              <div v-bind:style="{ backgroundColor: colors.pageBackground }">
              <h1 class="jobs_page_title jobs_page_title_customize" v-bind:style="{ color: colors.pageText }">
                <template v-for="(headingSetting, index) in headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted)">
                  <span :key="'h' + index">
                    {{headingSetting.display_name}} <span v-if="index < headingSettings.filter(headingSetting => !headingSetting.itemResourceDeleted).length - 1">/</span>
                  </span>
                </template>
              </h1>

              <div class="jobs_detail_text" v-bind:style="{ color: colors.pageText }"
                  v-for="(bodySetting, index) in bodySettings" :key="index">
                 <span :key="'b' + index">
                    {{bodySetting.display_name}}
                  </span>
              </div>

              <template v-for="(category, cIndex) in categoriesJobDetail">
                <template v-if="category && !category.categoryDeleted && !isEmptyCategory(categoriesJobDetail, cIndex)">
                  <h2 class="jobs_category_title" :key="'cd' + cIndex"
                      v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                    {{ category.categoryName }}
                  </h2>
                  <div class="jobs_table_wrapper" :key="'tb' + cIndex">
                    <table class="jobs_detail_table">
                      <tbody class="jobs_detail_table_body">
                        <template v-for="(item, index) in category.item">
                          <tr class="jobs_detail_table_rows"
                              v-bind:key="item.resourceField[0].name">
                            <th class="jobs_detail_table_head"
                                v-bind:style="[{ backgroundColor: colors.subColor }, index === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                              <span v-bind:style="{ color: colors.pageText }" class="setting_word_break">
                                {{ item.itemName }}
                              </span>
                            </th>
                            <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}">
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>
              </template>

              <div class="jobs_btn_box" v-if="commonSetting">
                <button v-if="commonSetting.jobInquiryUrl" class="jobs_btn_primary"
                        v-bind:style="{color: colors.mainButtonText, backgroundColor: colors.mainButton, border: '1px solid' + colors.borderColor}">
                  <span v-if="button.contactBtn === ''">
                    {{ searchJobLabelsProperty.BUTTON_CONTACT }}
                  </span>
                  <span v-else>
                    {{ button.contactBtn }}
                  </span>
                </button>
                <button v-if="commonSetting.entryPublic" class="jobs_btn_primary"
                        v-bind:style="{color: colors.mainButtonText, backgroundColor: colors.mainButton, border: '1px solid' + colors.borderColor}">
                  <span v-if="button.detailBtn === ''">
                    {{ searchJobLabelsProperty.BUTTON_APPLY_JOB }}
                  </span>
                  <span v-else>
                    {{ button.detailBtn }}
                  </span>
                </button>
              </div>
              <div class="jobs_detail_back">
                <button class="jobs_btn_secondary jobs_btn_medium" @click="step = 2; scrollToTopOfModal()"
                        v-bind:style="{color: colors.subButtonText, backgroundColor: colors.subButton, border: '1px solid' + colors.borderColor,}">
                  {{ searchJobLabelsProperty.RETURN_JOB_SEARCH_TOP }}
                </button>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
      <div class="setting_customize_footer">
        <div class="setting_customize_footer_button">
          <button
            class="setting_btn_outline setting_btn_small"
            @click="$emit('close'); step = 1"
          >
            {{ labelProperties.BUTTON_CLOSE_MODAL }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from "../../GeneralComponents/InputComponent.vue";
import labelProperties from "../../../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";
import searchJobLabelsProperty from "../../../../properties/user_search_job_screen/search-job-labels.json";
import moment from "moment";

export default {
  name: "CustomizeScreenModal",
  props: [
    "categoriesSearchJob",
    "colors",
    "masters",
    "button",
    "jobPageName",
    "numberOfJobDisplay",
    "headingSettings",
    "bodySettings",
    "categoriesJobList",
    "categoriesJobDetail",
    "commonSetting",
    "jobOverview"
  ],
  components: {
    InputComponent,
  },
  data: function () {
    return {
      messages: [],
      master: [],
      resource: {},
      isDisableEditing: true,
      labelProperties: labelProperties,
      searchJobLabelsProperty: searchJobLabelsProperty,
      condition: "or",
      step: 1,
      freeWord: "",
      numberOfSearchByItem: 0,
      jobDetails: [],
    };
  },
  methods: {
    scrollToTopOfModal(){
      document.getElementById("top_modal_preview").scrollIntoView();
    },
    isEmptyCategory(categoriesJob, index) {
      return (!categoriesJob || !categoriesJob[index] || categoriesJob[index].item.length === 0);
    },

    searchJob(){
      this.jobDetails = Array.from(Array(Number(this.numberOfJobDisplay)), (d, i) => i + 1);
      this.checkItemSearchHasValue();
      this.step = 2;
      this.scrollToTopOfModal();
    },
    checkItemSearchHasValue() {
      this.numberOfSearchByItem = 0;
      this.categoriesSearchJob.forEach(category => category.item.filter(itemJob => itemJob.resourceField && itemJob.resourceField.length > 0).forEach(itemJob => {
        itemJob.resourceField.forEach(resource => {
          if (resource.type === "checkbox" || resource.type === "multi_select") {
            resource['isHasValue'] = resource && resource.default_value && resource.default_value.length;
          } else {
            resource['isHasValue'] = resource && (resource.default_value || resource.default_value_from || resource.default_value_to);
          }
          resource['isHasValue'] ? this.numberOfSearchByItem++ : this.numberOfSearchByItem;
        });
      }));
    },
    getValueTime(value) {
      let timeFrom = "";
      let timeTo = "";
      if (value.default_value_from) {
        timeFrom = moment(value.default_value_from).format("HH:mm");
      }

      if (value.default_value_to) {
        timeTo = moment(value.default_value_to).format("HH:mm");
      }

      let stringTime = "";
      if (timeFrom !== "" && timeTo !== "") {
        stringTime = timeFrom + " ~ " + timeTo;
      }

      if (timeFrom !== "" && timeTo === "") {
        stringTime = timeFrom;
      }

      if (timeFrom === "" && timeTo !== "") {
        stringTime = timeTo;
      }

      if (stringTime === "") {
        stringTime = "--";
      }

      return stringTime;
    },

    getValueYearMonth(value) {
      let ymFrom = "";
      let ymTo = "";
      if (value.default_value_from) {
        ymFrom = moment(value.default_value_from).format("yyyy/MM");
      }

      if (value.default_value_to) {
        ymTo = moment(value.default_value_to).format("yyyy/MM");
      }

      let stringYM = "";
      if (ymFrom !== "" && ymTo !== "") {
        stringYM = ymFrom + " ~ " + ymTo;
      }

      if (ymFrom !== "" && ymTo === "") {
        stringYM = ymFrom;
      }

      if (ymFrom === "" && ymTo !== "") {
        stringYM = ymTo;
      }

      if (stringYM === "") {
        stringYM = "--";
      }

      return stringYM;
    },

    getValueDate(value) {
      let dateFrom = "";
      let dateTo = "";
      if (value.default_value_from) {
        dateFrom = moment(value.default_value_from).format("YYYY-MM-DD");
      }

      if (value.default_value_to) {
        dateTo = moment(value.default_value_to).format("YYYY-MM-DD");
      }

      let stringDate = "";
      if (dateFrom !== "" && dateTo !== "") {
        stringDate = dateFrom + " ~ " + dateTo;
      }

      if (dateFrom !== "" && dateTo === "") {
        stringDate = dateFrom;
      }

      if (dateFrom === "" && dateTo !== "") {
        stringDate = dateTo;
      }

      if (stringDate === "") {
        stringDate = "--";
      }

      return stringDate;
    },
    getValueDateTime(value) {
      let dateTimeFrom = "";
      let dateTimeTo = "";
      if (value.default_value_from) {
        dateTimeFrom = moment(value.default_value_from).format("YYYY-MM-DD HH:mm");
      }

      if (value.default_value_to) {
        dateTimeTo = moment(value.default_value_to).format("YYYY-MM-DD HH:mm");
      }

      let stringDateTime = "";
      if (dateTimeFrom !== "" && dateTimeTo !== "") {
        stringDateTime = dateTimeFrom + " ~ " + dateTimeTo;
      }

      if (dateTimeFrom !== "" && dateTimeTo === "") {
        stringDateTime = dateTimeFrom;
      }

      if (dateTimeFrom === "" && dateTimeTo !== "") {
        stringDateTime = dateTimeTo;
      }

      if (stringDateTime === "") {
        stringDateTime = "--";
      }

      return stringDateTime;
    },

    getValueCheckBox(values) {
      let valuesChecked = [];
      values.forEach(value => {
        if (!valuesChecked.includes(value)) {
          if (value.choiceDisplayName) {
            valuesChecked.push(value.choiceDisplayName);
          } else {
            valuesChecked.push(value.choiceName);
          }
        }
      });

      return valuesChecked.join(", ");
    },

    getSingleSelect(resource) {
      if (!resource || !resource.default_value) {
        return "--";
      }

      if (resource.name === 'company_id' || resource.name === 'staff_id' || resource.name === 'user_id') {
        return resource.default_value;
      }

      if (!resource.default_value.show) {
        return "--";
      }

      let value = resource.default_value;
      return value.choiceDisplayName ? value.choiceDisplayName : value.choiceName;
    },
    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master_name === master) {
          return [...this.masters[master].items];
        }
      }
    },

    isEmptyCategoryInJobSearch(index) {
      if (this.categoriesSearchJob[index].item.length === 0) {
        return true;
      }

      return this.categoriesSearchJob[index].item.filter(item => !item.resourceField[0].isDeletedByMainSystem).length === 0;
    },
  },
};
</script>

<style lang="css" scoped>
.jobs_table_wrapper {
  margin-bottom: 32px;
}

.jobs_table {
  display: table;
  table-layout: fixed;
  width: 100%;
  border-top: 1px solid #ddd;
}

.jobs_table_head,
.jobs_table_cell {
  padding: 16px;
}

.jobs_table_head {
  display: table-cell;
  width: 300px;
  background-color: #f7f7f7;
}

.jobs_table_cell {
  display: block;
  padding-top: 0;
  width: 100%;
}

.setting_customize_preview {
  padding-left: unset !important;
}

.jobs_wrapper {
  padding: 10px !important;
  max-width: unset !important;
}

.setting_customize_footer {
  display: unset !important;
}

p {
  margin-bottom: 0 !important;
}

.jobs_search_setting{
  display: -webkit-box;
}

.jobs_page_title_customize {
  margin-bottom: 12px !important;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.setting_word_break {
  word-break: break-all;
}
</style>
